import InputLabel from '@mui/material/InputLabel';

export { InputLabel };
